import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';

interface IWorkingHourLabelResponse {
  count: number;
  data: {
    id: string;
    clinicId: string;
    externalId: string;
    serviceId: string;
    name: string;
    isScheduled: boolean;
  }[];
}

const useWorkingHourLabel = () => {
  const clinicId = loadSelectedClinicId();

  const { data, error, mutate } = useSWR(
    ['/block-scheduling/working-hour-labels', clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<IWorkingHourLabelResponse>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useWorkingHourLabel;
